module.exports = __webpack_public_path__ + "assets/img/c5f1a66e6e21f03002a374c73ad64e28.png";